/** @format */
import { css } from 'styled-components';

import { RequestPasswordResetConfirmationProps } from './index';

/**
 * Base styles for the request password reset confirmation component
 */
const baseStyles = css`
    text-align: center;
`;

/**
 * The request password reset confirmation component styles
 *
 * @param {RequestPasswordResetConfirmationProps} props The request password reset confirmation properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
export const styles = (props: RequestPasswordResetConfirmationProps) => css`
    ${baseStyles}
`;
